module.exports = __webpack_public_path__ + "img/confirm.60103ba3.jpg";